import { createFileRoute, redirect } from '@tanstack/react-router';

import { MakeupClassesSettings } from '~features/settings/makeup-classes/index';
import { checkMinRoleValue } from '~shared/utils/role-guard';
import { UserRoles } from '~entities/users';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute(
  '/_auth/_layout/_settings/makeup-classes',
)({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: MakeupClassesSettings,
});
